/**
 * CSV generation utilities.
 */

/**
 * Escape a CSV value according to RFC 4180.
 * Values containing commas, quotes, or newlines are wrapped in quotes.
 * Quotes within values are doubled.
 */
export const escapeCsvValue = (value: string | null | undefined): string => {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

/**
 * Generate a CSV string from headers and rows.
 * All values are properly escaped.
 */
export const generateCsv = (headers: string[], rows: string[][]): string => {
  const escapedHeaders = headers.map(escapeCsvValue).join(',');
  const escapedRows = rows.map((row) => row.map(escapeCsvValue).join(','));
  return [escapedHeaders, ...escapedRows].join('\n');
};
